import React from "react";
import { Dropdown, Flag } from "semantic-ui-react";
import LANGUAGES from "constants/languages";
import { useTranslation } from "react-i18next";
import { getTranslatedLanguage } from "services/common";

function LanguageMenu() {
  const { i18n } = useTranslation("common");
  const currentLanguage = i18n.language;
  const baseLanguage = currentLanguage.split("-")[0];

  let currentLng = LANGUAGES.find((lng) => lng.key === currentLanguage);

  if (!currentLng) {
    currentLng = LANGUAGES.find((lng) => lng.key.split("-")[0] === baseLanguage);
  }

  if (!currentLng) {
    currentLng = LANGUAGES[0];
  }

  const handleChangeLanguage = (lng) => {
    i18n.changeLanguage(lng.key);
  };

  return (
    <Dropdown
      item
      icon={<Flag name={currentLng.flag} />}
      simple
      direction="left"
      className="language-menu-trigger"
    >
      <Dropdown.Menu className="language-menu">
        {LANGUAGES.map((lng) => (
          <Dropdown.Item
            key={lng.key}
            onClick={() => handleChangeLanguage(lng)}
            active={lng.key === currentLng.key}
          >
            <Flag name={lng.flag} /> {getTranslatedLanguage(lng.tKey)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default LanguageMenu;
